const OnEscape = function (ev) {
  if (ev.keyCode === 27) {
    this.editItem.modal.hide()
  }
}

export default OnEscape
